import React, { useState, lazy } from 'react';
import { ChevronDownIcon, ChevronUpIcon, ExternalLinkIcon } from 'lucide-react';
interface IngredientCardProps {
  ingredient: {
    id: number;
    name: string;
    benefit: string;
    category: string[];
    lastUpdated: string;
    recommendedProducts: Array<{
      name: string;
      image: string;
      link: string;
    }>;
  };
}
export function IngredientCard({
  ingredient
}: IngredientCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-5467" data-mp="1ne7y0mnhwb02">
      {/* Header */}
      <div className="p-6" data-id="element-5468" data-mp="19oo0bv8ru3xm">
        <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5469" data-mp="19l9wsjodfool">
          {ingredient.name}
        </h3>
        <p className="text-gray-600 text-sm mb-4" data-id="element-5470" data-mp="1dmbzxbleskvu">{ingredient.benefit}</p>
        {/* Categories */}
        <div className="flex flex-wrap gap-2 mb-4" data-id="element-5471" data-mp="14o09paogfp3x">
          {ingredient.category.map((cat, index) => <span key={index} className="bg-blue-100 text-blue-700 text-xs font-medium px-3 py-1 rounded-full" data-id="element-5472" data-mp="x6bqvubj9gdg" data-mpi={index}>
              {cat}
            </span>)}
        </div>
        {/* Last Updated */}
        <p className="text-xs text-gray-500 mb-4" data-id="element-5473" data-mp="165qfspc1xivu">
          Last updated: {ingredient.lastUpdated}
        </p>

        {/* Learn More Link */}
        <a href="/categories" className="mb-4 inline-flex items-center font-bold text-brand transition-colors duration-150 hover:text-brand-dark" data-id="element-5474" data-mp="dicd0alo9t3t">
          Learn More <span className="ml-1" data-id="element-5475" data-mp="9exv1ee6b2nq">→</span>
        </a>

        {/* Expand Button */}
        <button onClick={() => setIsExpanded(!isExpanded)} className="w-full flex items-center justify-center gap-2 text-[#1e2b55] font-medium py-2 px-4 rounded-lg border border-[#1e2b55] hover:bg-blue-50 transition-colors" data-id="element-5476" data-mp="n9gsrcj69hzp">
          {isExpanded ? <>
              Hide Products
              <ChevronUpIcon className="w-4 h-4" data-id="element-5477" data-mp="1pv11b7l2kk9s" />
            </> : <>
              View Recommended Products
              <ChevronDownIcon className="w-4 h-4" data-id="element-5478" data-mp="1ut2ljvu8epmu" />
            </>}
        </button>
      </div>
      {/* Recommended Products - Expandable */}
      {isExpanded && <div className="border-t border-gray-200 bg-gray-50 p-6" data-id="element-5479" data-mp="24kfe6pnutjtx">
          <h4 className="text-sm font-bold text-gray-900 mb-4" data-id="element-5480" data-mp="24lqgsm5kcljg">
            Recommended Products:
          </h4>
          <div className="grid grid-cols-3 gap-3" data-id="element-5481" data-mp="1bv8hlw7yn4bb">
            {ingredient.recommendedProducts.map((product, index) => <a key={index} href={product.link} className="group flex flex-col items-center" data-id="element-5482" data-mp="1gttepmrx17vj" data-mpi={index}>
                <div className="w-full aspect-square bg-white rounded-lg overflow-hidden mb-2 border border-gray-200 group-hover:border-[#1e2b55] transition-colors" data-id="element-5483" data-mp="1kttxfjm1s58e">
                  <img src={product.image} alt={product.name} className="w-full h-full object-contain p-2 group-hover:scale-110 transition-transform" loading="lazy" decoding="async" width="150" height="150" data-id="element-5484" data-mp="2w9s7nqsyoxb7" />
                </div>
                <p className="text-xs text-center text-gray-700 group-hover:text-[#1e2b55] font-medium line-clamp-2" data-id="element-5485" data-mp="6va9wj9pqlhm">
                  {product.name}
                </p>
              </a>)}
          </div>
        </div>}
    </div>;
}